import React from 'react';

interface PageToolbarProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  /**
   * Отступ снизу. По умолчанию var(--space-l1) — стандарт L1 между блоками.
   * Передай 0 если отступом управляет gap родителя.
   */
  mb?: number | string;
}

/**
 * PageToolbar — стандартный верхний блок-тулбар страницы.
 * Использует стиль ts-card + класс tm-scope (CSS форм-элементов из TabMenu).
 * gap: var(--space-l3) — стандарт L3 для inline-элементов.
 * mb: var(--space-l1) по умолчанию — стандарт L1 между блоками.
 */
const PageToolbar: React.FC<PageToolbarProps> = ({
  children, style, className, mb = 'var(--space-l1)',
}) => (
  <div
    className={`ts-card tm-scope${className ? ` ${className}` : ''}`}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 'var(--space-l3)',
      padding: '10px 16px',
      flexWrap: 'wrap',
      flexShrink: 0,
      marginBottom: mb,
      overflow: 'visible',
      position: 'relative',
      zIndex: 'var(--z-toolbar)' as any,
      ...style,
    }}
  >
    {children}
  </div>
);

export default PageToolbar;
